import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import FetchStaff from "../../components/Admin/Fetch-From-Email"

const Fetch = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Fetch From Email | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <FetchStaff />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Fetch
